import { Input, Modal } from "antd";
import styles from "./SingleCardDetails.module.css";

const SingleCardDetails = ({
  cardOpen,
  setCardOpen,
  handleOk,
  handleCancel,
  titleValue,
  gst,
  gstAmt,
  cGstRate,
  cGstAmt,
  sGstRate,
  sGstAmt,
  iGstRate,
  iGstAmt,
  basicAmt,
  netAmt,
  smCode,
}) => {
  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#52bd91",
            borderRadius: "8px",
            padding: "4px 8px",
          }}
        >
          {titleValue}
        </strong>
      }
      open={cardOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      closable={false}
      okText="OK"
      cancelText="Cancel"
    >
      <div className={styles.cardContainer2}>
        <div className={styles.infoBox2}>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>SMCODE</span>
            <span className={styles.separator2}>:</span>
            <span className={styles.value4}>{smCode || "-"}</span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Basic.Amt</span>
            <span className={styles.separator2}>:</span>
            <span className={styles.value2}>{basicAmt.toFixed(0) || 0.0}</span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>
              GST@{gst.toFixed(0) + "%" || 0.0 + "%"}
            </span>
            <span className={styles.separator2}>:</span>
            <span className={styles.value2}>{gstAmt.toFixed(2) || 0.0}</span>
          </div>
          <div className={styles.rowTag3}>
            <span className={styles.label2}>
              CGST@{cGstRate.toFixed(0) + "%" || 0.0 + "%"} :{" "}
              <span className={styles.value3}>{cGstAmt.toFixed(2) || 0.0}</span>
            </span>
            <span className={styles.label2}>
              SGST@{sGstRate.toFixed(0) + "%" || 0.0 + "%"} :{" "}
              <span className={styles.value3}>{sGstAmt.toFixed(2) || 0.0}</span>
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Net.Amt</span>
            <span className={styles.separator2}>:</span>
            <span className={styles.value2}>{netAmt.toFixed(0) || 0.0}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SingleCardDetails;
